import { useParams } from 'react-router';
import { ActionButtons, Content, EditPathHeader } from './components';
import { ManagePathProvider } from './context';
import { PageContainer } from '@/components/shared/page-container';
import { PageSkeleton } from '@/components/shared/page-skeleton';
import { useShowPathManagement } from '@/data/learning-path/path-management';
import { useSetTitle } from '@/hooks/use-set-title';

export const EditPath = () => {
  const { pathId } = useParams<{ pathId: string }>();
  const { path, isLoading, error } = useShowPathManagement({
    pathId: pathId ?? '',
  });
  useSetTitle(path?.title ?? `Editar trilha: ${path?.title}`);

  if (isLoading || (!path && !error)) return <PageSkeleton />;

  return (
    <ManagePathProvider currentPath={path}>
      <PageContainer>
        <EditPathHeader />
        <Content />
      </PageContainer>
      <ActionButtons />
    </ManagePathProvider>
  );
};
